export default __webpack_public_path__ + "static/media/user.3b7d67cb.svg";